import React from "react";

type Props = {
    points: string[];
};

export const Points = ({ points }: Props) => (
    <ul className="list-disc pb-10 pt-3 space-y-1 pl-16">
        {points.map((point, index) => (
            <li key={index}>{point}</li>
        ))}
    </ul>
);
